import { createAction } from '@reduxjs/toolkit';
import { DependencyCheckResult } from './models';

/** Re-run every check (the page's Re-run button). */
export const RUN_DEPENDENCY_CHECKS = createAction(
  'ADMIN_DEPENDENCIES/RUN_CHECKS'
);

/** A run began; every row lands `pending` (or already resolved, e.g. skipped). */
export const DEPENDENCY_CHECKS_STARTED = createAction<{
  readonly startedAt: string;
  readonly results: ReadonlyArray<DependencyCheckResult>;
}>('ADMIN_DEPENDENCIES/CHECKS_STARTED');

/** One row finished; replaces the row with the same `configKey`. */
export const DEPENDENCY_CHECK_RESULT = createAction<DependencyCheckResult>(
  'ADMIN_DEPENDENCIES/CHECK_RESULT'
);

export const DEPENDENCY_CHECKS_FINISHED = createAction(
  'ADMIN_DEPENDENCIES/CHECKS_FINISHED'
);

/** callGraphQLApi requires lifecycle action types; nothing listens to these. */
export const ADMIN_DEPENDENCIES_NOOP = 'ADMIN_DEPENDENCIES/NOOP';
